import React from 'react';
import { connect } from 'react-redux';
import Validations from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { isMePunchingsValidator } from '../../../js/me/selectors';
const AdminValidationsPunchingsList = React.lazy(() =>
  import('./AdminValidationsPunchingsList')
);
const AdminValidationsPunchingsPage = ({ props, canManagePunchings }) => (
  <Validations scrolling>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        {canManagePunchings ? (
          <AdminValidationsPunchingsList {...props} />
        ) : (
          <ErrorBoundary code={304} />
        )}
      </React.Suspense>
    </ErrorBoundary>
  </Validations>
);

function mapStateToProps(state) {
  return {
    canManagePunchings: isMePunchingsValidator(state),
  };
}
export default connect(mapStateToProps)(AdminValidationsPunchingsPage);
